import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { getUserVouchers } from 'actions/profile';
import styles from '../ProfileStyles.module.scss';

const RedeemedCodes = () => {
    const dispatch = useDispatch();
    const { vouchers, vouchersLoading } = useSelector(state => state.profile);

    useEffect(() => {
        dispatch(getUserVouchers());
    }, [dispatch]);

    const formatDate = (dateString) => {
        if (!dateString || dateString === '0001-01-01T00:00:00') return 'N/A';
        return new Date(dateString).toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        });
    };

    if (vouchersLoading) {
        return (
            <div>
                <h2 className={styles.sectionTitle}>Redeemed Codes</h2>
                <div className={styles.loading}>
                    <div className={styles.loadingSpinner}></div>
                </div>
            </div>
        );
    }

    return (
        <div>
            <h2 className={styles.sectionTitle}>Redeemed Codes</h2>
            <p className={styles.sectionDescription}>
                A history of all the activation codes you've redeemed.
            </p>

            {vouchers.length === 0 ? (
                <div className={styles.card}>
                    <div className={styles.emptyState}>
                        <div className={styles.emptyIcon}>🎟️</div>
                        <h3 className={styles.emptyTitle}>No Codes Redeemed</h3>
                        <p className={styles.emptyText}>
                            You haven't redeemed any activation codes yet.
                            If you have a code, head to the redeem code page to add games to your account.
                        </p>
                        <Link to="/redeem-code" className={`${styles.button} ${styles.small}`}>
                            Redeem Code
                        </Link>
                    </div>
                </div>
            ) : (
                <>
                    {/* Desktop table view */}
                    <div className={`${styles.card} ${styles.desktopOnly}`}>
                        <table className={styles.vouchersTable}>
                            <thead>
                                <tr>
                                    <th>Code</th>
                                    <th>Product</th>
                                    <th>Redeemed</th>
                                </tr>
                            </thead>
                            <tbody>
                                {vouchers.map((voucher, index) => (
                                    <tr key={index}>
                                        <td>
                                            <span className={styles.voucherCode}>
                                                {voucher.voucherCodeMasked}
                                            </span>
                                        </td>
                                        <td>{voucher.gamePackName}</td>
                                        <td>{formatDate(voucher.redeemedOn)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Mobile card view */}
                    <div className={styles.voucherCards}>
                        {vouchers.map((voucher, index) => (
                            <div key={index} className={styles.card}>
                                <div className={styles.voucherCardHeader}>
                                    <span className={styles.voucherCode}>
                                        {voucher.voucherCodeMasked}
                                    </span>
                                </div>
                                <div className={styles.infoRow}>
                                    <span className={styles.infoLabel}>Product</span>
                                    <span className={styles.infoValue}>{voucher.gamePackName}</span>
                                </div>
                                <div className={styles.infoRow}>
                                    <span className={styles.infoLabel}>Redeemed</span>
                                    <span className={styles.infoValue}>{formatDate(voucher.redeemedOn)}</span>
                                </div>
                                {voucher.gameNames && voucher.gameNames.length > 0 && (
                                    <p className={styles.voucherCardGames}>
                                        Games: {voucher.gameNames.join(', ')}
                                    </p>
                                )}
                            </div>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
};

export default RedeemedCodes;
